import React from 'react';
import './home3.scss';
//import homeWidgetsData from '../../data/homeWidgetsData'
import "../../assets/scss/mdb.scss_";
import {Gallery} from "devextreme-react";
import Tiles from "./tile";
import Tiles2 from "./tile2";
import {data} from '../../data/envVarible'
import Tatenergosbyt from "./tatenergosbyt";


const renderGalleryItem = (itemData) => {
    return (
        <div>
    <div className="index-business--content">
        <div className="dx-card wide-card">
            <div className="row">
                <div className="col-lg-3 col-sm-1"></div>
                <div className="col-lg-6 col-sm-10 p20 center-content">
                    <div className="section-title animated fadeInLeft text-responsive">{itemData.h1}</div>
                    <div className="index-business--text animated delay-1s fadeInLeft">{itemData.subh1}</div>
                    {/* <Button
                        text="Перейти в кабинет"
                        type="default"
                        stylingMode="contained"
                    /> */}
                </div>
                <div className="col-lg-3 col-sm-1"></div>
            </div>
        </div>
    </div>
            <div className="index-business--img" style={{
                backgroundImage: `url(${process.env.PUBLIC_URL + itemData.path})`,
                width:'100%'
            }}/>
        </div>
    );
}

class Home3 extends React.Component {
  render() {
    return (
        <React.Fragment>
            <div className="homePage3 mb100">
                <div className="widget-container">
                    <Gallery
                        id="gallery"
                        dataSource={data[process.env.REACT_APP_NAME_ENV].gallery}
                        height={500}
                        animationEnabled={true}

                        slideshowDelay={6000}
                        loop={true}
                        width={'100%'}
                        showNavButtons={true}
                        showIndicator={true}
                        itemRender={renderGalleryItem}
                    />
                </div>
                {process.env.REACT_APP_NAME_ENV === 'tatenergosbyt' &&
                <Tatenergosbyt/>
                }
                {process.env.REACT_APP_NAME_ENV !== 'tatenergosbyt' &&
                    <>
                        <div className="container-fluid pt60 pb60">
                            <div className="container text-center">
                                <Tiles/>
                            </div>
                        </div>
                        <div className="container-fluid  pt60 pb60 dark-background">
                            <div className="container text-center">
                                <h2 className='main-color'><strong>{data[process.env.REACT_APP_NAME_ENV].slideTwoBottomHomePage.header}</strong></h2>
                                <p>{data[process.env.REACT_APP_NAME_ENV].slideTwoBottomHomePage.secondary}</p>
                                <Tiles2/>
                            </div>
                        </div>
                    </>
                }
                {/* <div className="container-fluid pt60">
                    <h2 className='main-color text-center'><strong>Личный кабинет</strong></h2>
                    <Home2/>
                </div> */}
            </div>
        </React.Fragment>
    );
  }
}

export default Home3
